import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Image,
  Textarea,
} from '@nextui-org/react';
import React, { useState } from 'react';
import {
  getTopicById,
  approveTopic,
  deletetopic,
} from '../../services/querys ';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import moment from 'moment';
import { message } from 'antd';

function ApprovalModal({ id }) {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();
  const [image, setImage] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const queryClient = useQueryClient();

  const {
    isLoading,
    data = [],
    error,
  } = useQuery({
    queryKey: ['topics', id],
    queryFn: () => getTopicById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  const { mutate: approvetopicMutation, isLoading: isAproveLoading } =
    useMutation({
      mutationFn: approveTopic,
      onError: (error) => {
        console.error('Error approve topic:', error);
        message.error(error?.response?.data?.error || error.message);
      },
      onSuccess: async () => {
        message.success('Approved!');
        await queryClient.invalidateQueries(['topics']);
      },
    });

  const { mutate: deleteTopicMutation, isLoading: isRemoveLoading } =
    useMutation({
      mutationFn: deletetopic,
      onError: (error) => {
        console.error('Error remove topic:', error);
        message.error(error?.response?.data?.error || error.message);
      },
      onSuccess: async () => {
        message.success('Remove Success!');
        await queryClient.invalidateQueries(['topics']);
      },
    });

  const closeModal = () => {
    onClose();
    setImage(null);
    setTitle('');
    setDescription('');
  };

  const handleApprove = () => {
    if (!data?.topicId) {
      message.error('Topic id not found');
      return;
    }
    approvetopicMutation(data.topicId);
    closeModal();
  };

  const handleRemove = () => {
    if (!data?.topicId) {
      message.error('Topic id not found');
      return;
    }
    deleteTopicMutation(data.topicId);
    closeModal();
  };

  return (
    <>
      <Button onPress={onOpen} className="bg-btn-color font-poppins text-black">
        View
      </Button>

      <Modal
        size="lg"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="center"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 font-poppins">
                Approval
              </ModalHeader>
              <ModalBody>
                <div className="flex flex-inline gap-5">
                  <p className="text-md font-poppins text-start">
                    <span className="mr-2 text-gray-200">Status:</span>
                    <span className="text-yellow-500">
                      {data?.approvalStatus}
                    </span>
                  </p>

                  <p className="text-md font-poppins  line-clamp-3 text-start text-gray-200">
                    Create: {moment(data?.updatedAt).fromNow()}
                  </p>
                </div>
                <Image
                  removeWrapper
                  alt="Relaxing app background"
                  className="z-0 w-full h-full object-cover"
                  src={data?.image[0]?.url || '/img/test.png'}
                />

                <Textarea
                  label="Description"
                  labelPlacement="outside"
                  value={data?.description}
                  className="max-w-full text-h6 font-poppins col-span-4 "
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  color="danger"
                  variant="light"
                  onPress={closeModal}
                  isLoading={isRemoveLoading}
                >
                  Cancel
                </Button>
                <Button color="danger" onPress={handleRemove}>
                  Remove
                </Button>
                <Button
                  color="success"
                  onPress={handleApprove}
                  isLoading={isAproveLoading}
                >
                  Approved
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}

export default ApprovalModal;
